import React from "react";

function ErrorContent() {
	return (
		<div className="page-content">
			<section className="text-center o-hidden pt-0">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="error-page">
								<span>4</span>
								<span className="rotateme">
									<span className="screen-reader-text">
										0
									</span>
								</span>
								<span>4</span>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default ErrorContent;
